var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component, Children, createRef } from "react";
import SliderPrev from "./SliderPrev";
import SliderNext from "./SliderNext";
import SliderNav from "./SliderNav";
import { Container, Slides, SlidesWrapper, Slide } from "./styled/slider";
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.slidesWrapperRef = createRef();
        _this.slidesRef = createRef();
        _this.mousePosX = 0;
        // Internal Index
        _this.currentSlideIndex = 0;
        _this.prevSlideIndex = 0;
        _this.nextSlideIndex = 0;
        _this.handleLoadAllImages = function () {
            if (_this.state.hasHovered)
                return;
            _this.setState({ hasHovered: true });
        };
        _this.handleKeyDown = function (e) {
            _this.props.onKeyDown && _this.props.onKeyDown(e);
            if (!_this.state.hasMultipleSlides)
                return;
            if (["ArrowRight", "ArrowUp", "PageUp"].includes(e.key)) {
                e.preventDefault();
                _this.handleNext();
            }
            else if (["ArrowLeft", "ArrowDown", "PageDown"].includes(e.key)) {
                e.preventDefault();
                _this.handlePrev();
            }
            else if (e.key === "Home") {
                e.preventDefault();
                _this.handleNav(0);
            }
            else if (e.key === "End") {
                e.preventDefault();
                _this.handleNav(_this.state.childrenArray.length - 1);
            }
        };
        _this.handleMouseDown = function (e) {
            if (!_this.state.hasMultipleSlides)
                return;
            var clientX = ((e.touches && e.touches[0]) || e).clientX;
            _this.mousePosX = clientX;
        };
        _this.handleTouchMove = function (e) {
            if (!_this.state.hasMultipleSlides || !_this.slidesWrapperRef.current)
                return;
            var clientX = ((e.touches && e.touches[0]) || e).clientX;
            var width = _this.slidesWrapperRef.current.getBoundingClientRect().width;
            var diff = clientX - _this.mousePosX;
            if (diff >= width ||
                diff <= -width ||
                clientX <= 0 ||
                _this.state.isSliding ||
                !_this.state.hasMultipleSlides) {
                return;
            }
            if (_this.slidesRef.current) {
                _this.slidesRef.current.style.transition = "transform 0s";
                _this.slidesRef.current.style.transform = "translateX(" + diff + "px)";
            }
        };
        _this.handleTouchEnd = function (e) {
            if (_this.state.isSliding ||
                !_this.state.hasMultipleSlides ||
                !_this.slidesWrapperRef.current) {
                return;
            }
            var clientX = ((e.changedTouches && e.changedTouches[0]) || e).clientX;
            var width = _this.slidesWrapperRef.current.getBoundingClientRect().width;
            var diff = (Math.abs(_this.mousePosX - clientX) / width) * 100;
            var threshold = 30; // this is the amount from the edge a user drags before we change slides.
            if (_this.mousePosX < clientX) {
                if (diff >= threshold) {
                    return _this.handlePrev();
                }
            }
            else if (_this.mousePosX > clientX) {
                if (diff >= threshold) {
                    return _this.handleNext();
                }
            }
            if (_this.slidesRef.current) {
                _this.slidesRef.current.style.transition = "transform " + _this.props.slideSpeed + "s";
                _this.slidesRef.current.style.transform = "translateX(0)";
            }
        };
        _this.handleTransitionEnd = function () {
            if (!_this.state.hasMultipleSlides)
                return;
            var currentSlideIndex = _this.currentSlideIndex;
            var prevSlideIndex = (currentSlideIndex + _this.state.childrenArray.length - 1) %
                _this.state.childrenArray.length;
            var nextSlideIndex = (currentSlideIndex + _this.state.childrenArray.length + 1) %
                _this.state.childrenArray.length;
            _this.setState({
                currentSlideIndex: currentSlideIndex,
                prevSlideIndex: prevSlideIndex,
                nextSlideIndex: nextSlideIndex,
                direction: null,
                isSliding: false
            }, function () {
                var _a = _this.state, currentSlideIndex = _a.currentSlideIndex, direction = _a.direction, isSliding = _a.isSliding;
                _this.props.onSlide &&
                    _this.props.onSlide({
                        currentSlideIndex: currentSlideIndex,
                        prevSlideIndex: prevSlideIndex,
                        nextSlideIndex: nextSlideIndex,
                        direction: direction,
                        isSliding: isSliding
                    });
            });
        };
        _this.handleNav = function (newSlideIndex, previousSlideIndex) {
            if ((newSlideIndex === _this.state.currentSlideIndex &&
                typeof previousSlideIndex === "undefined") ||
                _this.state.isSliding) {
                return;
            }
            var direction = "next";
            if (_this.state.currentSlideIndex === newSlideIndex) {
                if (previousSlideIndex) {
                    direction = previousSlideIndex > newSlideIndex ? "prev" : "next";
                }
            }
            else {
                direction =
                    _this.state.currentSlideIndex > newSlideIndex ? "prev" : "next";
            }
            _this.currentSlideIndex = newSlideIndex;
            _this.setState({
                prevSlideIndex: direction === "prev" ? newSlideIndex : _this.state.prevSlideIndex,
                nextSlideIndex: direction === "next" ? newSlideIndex : _this.state.nextSlideIndex,
                direction: direction,
                isSliding: true
            }, function () {
                if ((_this.props.slideSpeed || 0) <= 0) {
                    _this.handleTransitionEnd();
                }
                else {
                    _this.props.onNav &&
                        _this.props.onNav({
                            currentSlideIndex: _this.state.currentSlideIndex,
                            nextSlideIndex: newSlideIndex,
                            direction: _this.state.direction,
                            isSliding: _this.state.isSliding
                        });
                }
            });
        };
        _this.handlePrev = function () {
            if (_this.state.isSliding)
                return;
            var childrenLength = _this.state.childrenArray.length;
            var offset = _this.state.currentSlideIndex + childrenLength - 1;
            var nextSlideIndex = offset % childrenLength;
            var oldCurrentIndex = _this.currentSlideIndex;
            _this.currentSlideIndex = nextSlideIndex;
            _this.setState({
                direction: "prev",
                isSliding: true
            }, function () {
                if ((_this.props.slideSpeed || 0) <= 0) {
                    _this.handleTransitionEnd();
                }
                else {
                    _this.props.onPrev &&
                        _this.props.onPrev({
                            currentSlideIndex: oldCurrentIndex,
                            nextSlideIndex: nextSlideIndex,
                            direction: _this.state.direction,
                            isSliding: _this.state.isSliding
                        });
                }
            });
        };
        _this.handleNext = function () {
            if (_this.state.isSliding)
                return;
            var childrenLength = _this.state.childrenArray.length;
            var offset = _this.state.currentSlideIndex + childrenLength + 1;
            var nextSlideIndex = offset % childrenLength;
            var oldCurrentIndex = _this.currentSlideIndex;
            _this.currentSlideIndex = nextSlideIndex;
            _this.setState({
                direction: "next",
                isSliding: true
            }, function () {
                if ((_this.props.slideSpeed || 0) <= 0) {
                    _this.handleTransitionEnd();
                }
                else {
                    _this.props.onNext &&
                        _this.props.onNext({
                            currentSlideIndex: oldCurrentIndex,
                            nextSlideIndex: nextSlideIndex,
                            direction: _this.state.direction,
                            isSliding: _this.state.isSliding
                        });
                }
            });
        };
        var childrenArray = Children.toArray(_this.props.children);
        // If we only have two slides, double the slide count so we can mimic if we had 3+ slides.
        if (childrenArray.length === 2) {
            childrenArray = __spreadArrays(childrenArray, childrenArray);
        }
        var currentSlideIndex = _this.props.initialSlide || _this.props.currentSlideIndex || 0;
        var prevSlideIndex = (currentSlideIndex + childrenArray.length - 1) % childrenArray.length;
        var nextSlideIndex = (currentSlideIndex + childrenArray.length + 1) % childrenArray.length;
        _this.currentSlideIndex = currentSlideIndex;
        _this.prevSlideIndex = prevSlideIndex;
        _this.nextSlideIndex = nextSlideIndex;
        _this.state = {
            childrenArray: childrenArray,
            hasMultipleSlides: childrenArray.length > 1,
            currentSlideIndex: currentSlideIndex,
            prevSlideIndex: prevSlideIndex,
            nextSlideIndex: nextSlideIndex,
            direction: null,
            isSliding: false,
            hasHovered: _this.isTouchDevice()
        };
        return _this;
    }
    Slider.prototype.render = function () {
        var _this = this;
        var _a = this.props, onPrev = _a.onPrev, onNext = _a.onNext, onNav = _a.onNav, onSlide = _a.onSlide, children = _a.children, props = __rest(_a, ["onPrev", "onNext", "onNav", "onSlide", "children"]);
        var trueChildCount = Children.count(children);
        var delta = !this.state.direction
            ? 0
            : this.state.direction === "next"
                ? -1
                : 1;
        var slides = this.state.hasHovered
            ? this.state.childrenArray
            : this.state.childrenArray.slice(0, 1);
        return (React.createElement(Container, __assign({}, props, { "data-testid": "slider", onKeyDown: this.handleKeyDown, onMouseEnter: this.handleLoadAllImages }),
            React.createElement(SlidesWrapper, { ref: this.slidesWrapperRef },
                React.createElement(Slides, { ref: this.slidesRef, tabIndex: 0, "aria-live": "polite", style: {
                        transform: "translateX(" + delta * 100 + "%)",
                        transition: this.state.isSliding
                            ? "transform " + this.props.slideSpeed + "s"
                            : "transform 0s"
                    }, onTouchStart: this.handleMouseDown, onTouchMove: this.handleTouchMove, onTouchEnd: this.handleTouchEnd, onTransitionEnd: this.handleTransitionEnd, onFocus: this.handleLoadAllImages }, slides.map(function (child, index) {
                    var isPrev = index === _this.state.prevSlideIndex &&
                        _this.state.hasMultipleSlides;
                    var isNext = index === _this.state.nextSlideIndex &&
                        _this.state.hasMultipleSlides;
                    var isCurrent = index === _this.state.currentSlideIndex;
                    return (React.createElement(Slide, { key: index, isPrev: isPrev, isNext: isNext, isCurrent: isCurrent, "aria-hidden": !isCurrent, "data-testid": isPrev
                            ? "prev-slide"
                            : isNext
                                ? "next-slide"
                                : isCurrent
                                    ? "current-slide"
                                    : "slide" }, child));
                }))),
            this.state.hasMultipleSlides && (React.createElement(React.Fragment, null,
                this.props.showArrows && (React.createElement(React.Fragment, null,
                    React.createElement(SliderPrev, { onClick: this.handlePrev }),
                    React.createElement(SliderNext, { onClick: this.handleNext }))),
                this.props.showDots && (React.createElement(SliderNav, { currentSlideIndex: trueChildCount === 2
                        ? this.currentSlideIndex % 2
                        : this.currentSlideIndex, slideCount: trueChildCount, dotsToShow: this.props.dotsToShow, slideSpeed: this.props.slideSpeed, onClick: this.handleNav }))))));
    };
    Slider.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.autoFocus) {
            setTimeout(function () { var _a; return (_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
        }
    };
    Slider.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (typeof this.props.currentSlideIndex === "number" &&
            this.props.currentSlideIndex !== prevProps.currentSlideIndex) {
            this.handleNav(this.props.currentSlideIndex, prevProps.currentSlideIndex);
        }
        if (this.props.autoFocus) {
            setTimeout(function () {
                var _a;
                (_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    };
    Slider.prototype.isTouchDevice = function () {
        return ("ontouchstart" in window ||
            window.matchMedia("(any-pointer: coarse)").matches);
    };
    Slider.defaultProps = {
        initialSlide: 0,
        autoFocus: false,
        showArrows: true,
        showDots: true,
        dotsToShow: 7,
        slideSpeed: 0.2,
        onPrev: function () { },
        onNext: function () { },
        onNav: function () { },
        onSlide: function () { },
        onKeyDown: function () { }
    };
    return Slider;
}(Component));
export default Slider;
